import ShortCustomerList from '@/features/Contact/ShortCustomerList';
import useShortCustomerList from '@/hooks/domain/useShortCustomerList';
import { DETAIL_MODAL_TYPE } from '@/stores/pure/DetailModalStore';
import { CONTACT_COLUMNS } from '@/types/filterKeyConst';

type Props = {
  companyAlias: string;
  onSelectNewModal: (alias: string, type: DETAIL_MODAL_TYPE) => void;
};

const CompanyContactTab = (props: Props) => {
  const {
    customers,
    customerLoading,
    hasCustomerNext,
    customerNextClickHandler,
  } = useShortCustomerList(CONTACT_COLUMNS.ACCOUNT, props.companyAlias);
  return (
    <ShortCustomerList
      customers={customers || []}
      loading={customerLoading}
      hasNextPage={hasCustomerNext}
      nextClickHandler={customerNextClickHandler}
      onItemClick={(alias) => {
        props.onSelectNewModal(alias, DETAIL_MODAL_TYPE.CUSTOMER);
      }}
    />
  );
};

export default CompanyContactTab;
